var React = require('react');

function IcEmoji (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2ZM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8Zm5-10.5c0 .83-.67 1.5-1.5 1.5S14 10.33 14 9.5 14.67 8 15.5 8s1.5.67 1.5 1.5ZM8.5 11c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11Zm8.61 3c-.8 2.04-2.78 3.5-5.11 3.5-2.33 0-4.31-1.46-5.11-3.5h10.22Z","fill":"currentColor"}));
}

IcEmoji.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = IcEmoji;

IcEmoji.default = IcEmoji;
